const Provider = require("./Provider");
const PropTypes = require("prop-types");
const {observable} = require("mobx");
const inject = require("../decorators/Injector");

@inject(["store"])
class Data extends Provider {

    @observable data = new Map();

    constructor(props) {
        super(props);

        if (props.data !== null) {
            //console.log('setting data from prop');
            this.setData(props.data);
        } else if (props.store && typeof(props.store.onActiveUpdated) === 'function') {
            //console.log('setting data from store');
            this.setData(props.store.active);

            //console.log(props.store);

            props.store.onActiveUpdated('data_provider_' + this.provider_uuid, () => {
                //console.log('IN DATA, store updated', props.store.active);

                this.setData(props.store.active);

                //this.updateUuid();

                //console.log('TEST', props.store.resource, this.data.id, this.data);
            });

        } else {
            //console.log('setting data from default');
            this.data = {};
        }

    }

    setData(data){
        if(data === null){
            data = {};
        }
        //this.data = data;
        this.data.replace(data);
        //console.log(this.data);
    }

    componentDidUpdate(prevProps) {

        if (prevProps.data !== this.props.data) {
            if (
                (prevProps.data !== null && typeof prevProps.data !== 'undefined' && (Object.keys(prevProps.data).length === 0)) &&
                (this.props.data !== null && typeof this.props.data !== 'undefined' && (Object.keys(this.props.data).length === 0))
            ) {
                return;
            }
            //console.log('SETTING DATA FROM PROPS', prevProps.data, this.props.data, this.props.data);

            this.setData(this.props.data);

            this.updateUuid();
        }

        /*
        if (prevProps.store !== this.props.store) {
            console.log('SETTING DATA FROM STORE', this.props.store);
            this.data = this.props.store.active;
            this.updateUuid();
        }*/
    }

    componentWillUnmount(){
        if(this.props.store && typeof(this.props.store.onActiveUpdated) === 'function'){
            this.props.store.removeOnActiveUpdatedCallback('data_provider_' + this.provider_uuid);
        }
    }

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {
            data: PropTypes.any
        };
    }

    static get defaultProps() {
        return {
            data: null
        };
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    resolveData() {
        return this.data;
    }

    get providerProps() {
        return {
            data: this.resolveData()
        };
    }

}

module.exports = Data;
